//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createOrReplaceOperation } from '@/lib/images'

export default {
  name: 'MediaVideoPreview',
  props: {
    media: {
      type: Object,
      required: true
    },
    displayCoverImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      playVideo: false,
      displayThumbnail:
        (this.displayCoverImage && !!this.media.coverImage) ||
        !!this.media.thumbnailUrl
    }
  },
  computed: {
    thumbnailUrl() {
      if (this.displayCoverImage && this.media.coverImage) {
        return this.media.coverImage.url
      }

      return createOrReplaceOperation(
        this.media.thumbnailUrl,
        'preview',
        '1200x1200'
      )
    }
  },
  methods: {
    thumbnailClicked() {
      this.displayThumbnail = false
      this.$nextTick(() => {
        this.playPauseVideo()
      })
    },
    playPauseVideo() {
      this.playVideo = !this.playVideo
      const video = this.$refs.video
      if (this.playVideo) {
        video.play()
        video.addEventListener('timeupdate', () => {
          this.$emit('videoPositionUpdated', video.currentTime, video.duration)
        })
      } else {
        video.pause()
      }
    }
  }
}
